/**
 * Splits requested column names into those present in the queried table and
 * those absent from it.
 *
 * Column names reach the competitor queries as raw string interpolation, and
 * `dashboardVariables` is persisted config that can drift from the file it was
 * derived from. Referencing an absent column makes DuckDB raise a
 * `Binder Error`, which propagates to the router error boundary and takes the
 * whole dashboard route down (AAPD-678). Every name must therefore be checked
 * against `DESCRIBE` first.
 *
 * Matching is case-sensitive, matching DuckDB's quoted-identifier semantics:
 * the input file carries `C-TELIA_TV_Inv` while the model emits
 * `C-Telia_Total_Inv`, and those are genuinely different columns.
 *
 * @param requested Column names the query wants, in the order it wants them.
 * @param existing Column names the table actually has (from `DESCRIBE`).
 * @returns `present` in requested order, and `missing` in requested order.
 */
export const partitionExistingColumns = (
    requested: string[],
    existing: string[],
): { present: string[]; missing: string[] } => {
    const existingSet = new Set(existing);
    const present: string[] = [];
    const missing: string[] = [];

    for (const name of requested) {
        if (existingSet.has(name)) {
            present.push(name);
        } else {
            missing.push(name);
        }
    }

    return { present, missing };
};
